module.exports = __webpack_public_path__ + "static/img/brees-2011-slide-1.2505878.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-slide-1.jpg
// module id = I3SI
// module chunks = 1